function getOffsetTopToRoot(node) {
  return node ? node.offsetTop + getOffsetTopToRoot(node.offsetParent) : 0
}

export function getScrollParent(element) {
  const parent = element.parentElement

  if (parent) {
    const { overflow, overflowY } = getComputedStyle(parent)

    if (/(auto|scroll|overlay)/.test(overflow + overflowY)) {
      return parent
    }

    return getScrollParent(parent)
  }
}

export function getScrollContext(element) {
  const scrollParent = getScrollParent(element)

  if (scrollParent) {
    return { eventTarget: scrollParent, scrollElement: scrollParent }
  }

  return {
    eventTarget: window,
    scrollElement: document.scrollingElement || document.documentElement,
  }
}

export function getNaturalOffsetTop(element, scrollParent) {
  return getOffsetTopToRoot(element) - getOffsetTopToRoot(scrollParent)
}
